export default __webpack_public_path__ + "static/media/t3.6da4f14c.svg";